import React, { createContext, useState, useCallback } from "react";

export const UpdateContext = createContext();

export const UpdateProvider = ({ children }) => {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [registration, setRegistration] = useState(null);

  const notifyUpdate = useCallback((registration) => {
    setRegistration(registration);
    setUpdateAvailable(true);
  }, []);

  const skipUpdate = useCallback(() => {
    setUpdateAvailable(false);
    setRegistration(null);
  }, []);

  const applyUpdate = useCallback(() => {
    if (registration && registration.waiting) {
      registration.waiting.postMessage({ type: "SKIP_WAITING" });
      window.location.reload();
    }
  }, [registration]);

  return (
    <UpdateContext.Provider
      value={{
        updateAvailable,
        notifyUpdate,
        skipUpdate,
        applyUpdate,
      }}
    >
      {children}
    </UpdateContext.Provider>
  );
};
